import { stringifyDocValue, parseDocValue } from "./parse.js";
const convertMap = {
  object: {
    array: objectToArray,
    string: stringifyDocValue
  },
  array: {
    object: arrayToObject,
    string: stringifyDocValue
  },
  string: {
    object: stringToObject,
    array: stringToArray,
    number: parseInt,
    boolean: stringToBoolean
  },
  number: {
    string: numberToString,
    boolean: numberToBoolean
  },
  boolean: {
    string: booleanToString,
    number: booleanToNumber
  }
};
function convert(from, to, value) {
  var _a, _b;
  return (_b = (_a = convertMap[from]) == null ? void 0 : _a[to]) == null ? void 0 : _b.call(_a, value);
}
function objectToArray(object) {
  return Object.values(object);
}
function arrayToObject(array) {
  return {
    ...array
  };
}
function stringToObject(string) {
  const value = parseDocValue(string);
  return Array.isArray(value) ? arrayToObject(value) : value;
}
function stringToArray(string) {
  const value = parseDocValue(string);
  return Array.isArray(value) ? value : objectToArray(value);
}
function stringToBoolean(string) {
  return string === "true";
}
function numberToString(number) {
  return number ? number.toString() : null;
}
function numberToBoolean(number) {
  return number === 1;
}
function booleanToString(boolean) {
  return boolean ? "true" : "false";
}
function booleanToNumber(boolean) {
  return boolean ? 1 : 0;
}
export {
  convert
};
//# sourceMappingURL=convert.js.map
